import { addTransitionClass, removeTransitionClass, whenTransitionEnds } from 'intact-vue';
export function useTransition(getFeedback) {
  var transition = 'k-slidedown';
  function onEnter(el, done) {
    getFeedback(function (feedback) {
      transition = getTransition(feedback);
      var enterFromClass = transition + "-enter-from";
      var enterActiveClass = transition + "-enter-active";
      addTransitionClass(el, enterFromClass);
      document.body.offsetWidth;
      addTransitionClass(el, enterActiveClass);
      removeTransitionClass(el, enterFromClass);
      whenTransitionEnds(el, function () {
        onEnterCancelled(el);
        done();
      });
    });
  }
  function onEnterCancelled(el) {
    removeTransitionClass(el, transition + "-enter-active");
  }
  function onLeave(el, done) {
    // maybe the position has changed, so we re-get it
    getFeedback(function (feedback) {
      transition = getTransition(feedback);
      addTransitionClass(el, transition + "-leave-to");
      addTransitionClass(el, transition + "-leave-active");
      whenTransitionEnds(el, function () {
        onLeaveCancelled(el);
        done();
      });
    });
  }
  function onLeaveCancelled(el) {
    removeTransitionClass(el, transition + "-leave-to");
    removeTransitionClass(el, transition + "-leave-active");
  }
  return {
    onEnter: onEnter,
    onEnterCancelled: onEnterCancelled,
    onLeave: onLeave,
    onLeaveCancelled: onLeaveCancelled
  };
}
function getTransition(feedback) {
  var horizontal = feedback.horizontal;
  var vertical = feedback.vertical;
  if (feedback.important === 'horizontal') {
    if (horizontal === 'left') {
      return 'k-slideright';
    } else if (horizontal === 'right') {
      return 'k-slideleft';
    } else if (vertical === 'bottom') {
      return 'k-slideup';
    } else if (vertical === 'top') {
      return 'k-slidedown';
    }
  } else {
    if (vertical === 'bottom') {
      return 'k-slideup';
    } else if (vertical === 'top') {
      return 'k-slidedown';
    } else if (horizontal === 'left') {
      return 'k-slideright';
    } else if (horizontal === 'right') {
      return 'k-slideleft';
    }
  }
  return 'k-slidedown';
}